/*
 * @Author: Chao Yang
 * @Date: 2020-09-08 10:02:53
 * @LastEditor: Chao Yang
 * @LastEditTime: 2020-10-13 14:37:53
 */
import { Injectable } from '@angular/core';
import { BaseProxy } from '../base.proxy';
import { Observable } from 'rxjs';
import { OfferingDetailLayout } from '../../model/offering/offeringDetailLayout.model';
import { OfferingDetailSummary } from '../../model/offering/offeringDetailSummary.model';
import { OfferingDetailContact } from '../../model/offering/offeringDetailContact.model';
import { OfferingDetailDocument } from '../../model/offering/offeringDetailDocument.model';
import { OfferingDetailFolder } from '../../model/offering/offeringDetailFolder.model';
import { OfferingDetailImage } from '../../model/offering/offeringDetailImage.model';
import { OfferingDetailVideo } from '../../model/offering/offeringDetailVideo.model';
import { ITrackRecord } from '../../model/offering/editor/i-track-record.model';

@Injectable()
export class OfferingProxy extends BaseProxy {
  getOfferingDetailLayout(fundId: number): Observable<OfferingDetailLayout> {
    return this._http.get<OfferingDetailLayout>(
      `/ip/api/layout/fund/${fundId}/marketing`
    );
  }

  getOfferingDetailSummary(fundId: number): Observable<OfferingDetailSummary> {
    return this._http.get<OfferingDetailSummary>(
      `/ip/api/fund/${fundId}/marketing`
    );
  }

  getOfferingDetailContact(
    fundId: number
  ): Observable<OfferingDetailContact[]> {
    return this._http.get<OfferingDetailContact[]>(
      `/ip/api/contact/fund/${fundId}/marketing`
    );
  }

  getOfferingDetailDocument(
    fundId: number
  ): Observable<OfferingDetailFolder[]> {
    return this._http.get<OfferingDetailFolder[]>(
      `/ip/api/folder/fund/${fundId}/marketing`
    );
  }

  getOfferingDetailImages(fundId: number) {
    return this._http.get<OfferingDetailImage[]>(
      `/ip/api/fund/${fundId}/images`
    );
  }
  getOfferingDetailVideos(fundId: number) {
    return this._http.get<OfferingDetailVideo[]>(
      `/ip/api/fund/${fundId}/videos`
    );
  }

  getFundBannerImage(fundId: number): Observable<string> {
    return this._http.get<string>(`/ip/api/fund/${fundId}/banner/image`);
  }

  getTrackRecord(fundId: number): Observable<ITrackRecord> {
    return this._http.get<ITrackRecord>(`/ip/api/fund/${fundId}/marketing/trackrecord`);
  }
}
